const HOST = process.env.VUE_APP_LOCALHOST || window.location.host;

export const WS_API = `wss://${HOST}/ws`;

export const ERROR_EVENT_NOT_FOUND = 'EVENT_NOT_FOUND';

export const ERROR_EVENT_COMING_SOON = 'EVENT_COMING_SOON';

export const INFO_EVENT_PROTECTED = 'EVENT_PROTECTED';

export const ERROR_UNAUTHORIZED = 'ERROR_UNAUTHORIZED';

export const BASE_DOMAIN = `https://${HOST}/`;

export const API_DOMAIN = `${BASE_DOMAIN}api/`;

export const ASSETS_DOMAIN = `${BASE_DOMAIN}assets/`;

// Shows / Hides the Reactions feature
export const REACTIONS_FEATURE_FLAG = parseInt(process.env.VUE_APP_REACTIONS_FEATURE_FLAG ||'0') === 1 ? true: false;

export const REACTIONS_API_ENDPOINT = process.env.VUE_APP_REACTIONS_API_ENDPOINT;

export const DEFAULT_STYLE = {
  'font-family': 'brandon-grotesque, sans-serif',
  'text-align': 'center',
  'color': '#2c3e50',
  'background-color': '#000',
  'background-repeat': 'repeat-y',
  'background-attachment': 'fixed',
  'background-size': '100% auto',
  '--button-text-color': '#fff',
  '--button-text-font-size': '18px',
  '--button-background-color': '#000',
  '--button-hover-text-color': '#000',
  '--button-hover-background-color': '#fff',
  '--popup-background-color': '#fff',
  '--text-color': '#000',
  '--font-family': 'sans-serif',
  '--font-size': '18px',
};

console.log(BASE_DOMAIN);
